import React from "react";
import { 
  IoCashOutline, 
  IoSwapHorizontalOutline, 
  IoPersonOutline,
  IoCalendarOutline,
  IoDocumentTextOutline
} from "react-icons/io5";
import "./ActionHistoryCards.css";
import { formatPrice } from "../../utils/formatPrice";

const ActionHistoryCards = ({ orderData }) => {
  const order = orderData?.data?.order;
  const actionHistories = order?.action_histories || [];

  if (!order || actionHistories.length === 0) {
    return (
      <div className="card shadow-sm border-0 rounded-4 action-history-card">
        <div className="card-body p-4">
          <div className="text-center text-muted py-3">
            لا توجد سجلات إجراءات للطلب
          </div>
        </div>
      </div>
    );
  }

  // Action type configurations
  const getActionConfig = (actionType) => {
    const configs = {
      refund_item: {
        label: "استرداد مبلغ",
        icon: <IoCashOutline className="action-icon" />,
        color: "#dc3545",
        bgColor: "#fff5f5"
      },
      replace_item: {
        label: "استبدال صنف",
        icon: <IoSwapHorizontalOutline className="action-icon" />,
        color: "#198754",
        bgColor: "#f0fff4"
      },
      refund_order: {
        label: "استرداد طلب",
        icon: <IoCashOutline className="action-icon" />,
        color: "#dc3545",
        bgColor: "#fff5f5"
      },
      cancel_order: {
        label: "إلغاء طلب",
        icon: <IoDocumentTextOutline className="action-icon" />,
        color: "#6c757d",
        bgColor: "#f8f9fa"
      },
      update_status: {
        label: "تحديث حالة",
        icon: <IoCalendarOutline className="action-icon" />,
        color: "#0d6efd",
        bgColor: "#e7f1ff"
      }
    };

    return configs[actionType] || {
      label: actionType,
      icon: <IoPersonOutline className="action-icon" />,
      color: "#6c757d",
      bgColor: "#f8f9fa"
    };
  };

  const formatAmount = (amount) => {
    if (!amount || amount === 0) return "مجاناً";
    return `${amount} EGP`;
  };

  const getMetadataText = (metadata) => {
    if (!metadata) return "";
    
    const parts = [];
    
    if (metadata.quantity && metadata.quantity > 0) {
      parts.push(`الكمية: ${metadata.quantity}`);
    }
    
    if (metadata.voucher_code) {
      parts.push(`كود الخصم: ${metadata.voucher_code}`);
    }
    
    if (metadata.replacement_item_id) {
      parts.push(`رقم الصنف المستبدل: ${metadata.replacement_item_id}`);
    }
    
    return parts.length > 0 ? parts.join(" • ") : "";
  };

  return (
    <div className="card shadow-sm border-0 rounded-4 action-history-card">
      <div className="card-body p-4">
        {/* Header */}
        <div className="d-flex align-items-center mb-3">
          <IoDocumentTextOutline className="text-primary me-2 fs-4" />
          <h6 className="mb-0 fw-bold">سجل الإجراءات</h6>
          <span className="badge bg-primary ms-2">{actionHistories.length}</span>
        </div>

        {/* Action History Cards */}
        <div className="action-history-list">
          {actionHistories.map((action, index) => {
            const config = getActionConfig(action.action_type);
            const metadataText = getMetadataText(action.metadata);

            return (
              <div key={action.id} className="action-card mb-3">
                <div className="action-header d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div 
                      className="action-type-icon d-flex align-items-center justify-content-center"
                      style={{ backgroundColor: config.bgColor, color: config.color }}
                    >
                      {config.icon}
                    </div>
                    <div className="ms-3">
                      <h6 className="mb-1 fw-semibold" style={{ color: config.color }}>
                        {config.label}
                      </h6>
                      {action.reason && (
                        <p className="mb-1 text-muted small">{action.reason}</p>
                      )}
                    </div>
                  </div>
                  
                  <div className="action-meta text-end">
                    <div className="action-amount fw-bold" style={{ color: config.color }}>
                    
                    </div>
                    <div className="action-time text-muted small">
                      {new Date(action.created_at).toLocaleString()}
                    </div>
                  </div>
                </div>

                {/* Action Details */}
                <div className="action-details mt-2">
                  {metadataText && (
                    <div className="metadata-info text-muted small mb-2">
                      <IoDocumentTextOutline className="me-1" />
                      {metadataText}
                    </div>
                  )}
                  
                  <div className="actioned-by d-flex align-items-center text-muted small">
                    <IoPersonOutline className="me-2" />
                    <span>
                      {action.actioned_by?.name || "نظام"} 
                      {action.actioned_by?.type && (
                        <span className="text-secondary ms-1">
                          ({action.actioned_by.type.split('\\').pop()})
                        </span>
                      )}
                    </span>
                  </div>
                </div>

                {/* Divider */}
                {index < actionHistories.length - 1 && (
                  <hr className="my-3" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ActionHistoryCards;